import { getApplication } from "../../services/BaseService"

const app = getApplication();

export const config = {
  DASHBOARD_BACKGROUND: app === 'tazama' ? 'white' : 'var(--base-gray-20)',
  BOX_SHADOW: app === 'tazama' ? undefined : '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
  PADDING: 24,
  GAP: '4px',
  BORDER_RADIUS: '4px',
  BORDER_COLOR: 'var(--border-color)',
  TITLE: {
    FONT_SIZE: '20px',
    FONT_WEIGHT: 600,
    COLOR: 'var(--base-gray-90)',
  },
  TOOLTIP_ICON_COLOR: 'var(--base-gray-60)',
  TOOLTIP_ICON_SIZE: 14,
}
